/**
 *    @author:
 *    @since:
 *
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputData } from '../../_common/data/input-data';
import { ItemList } from '../../_common/constant/item-list';
import { Path } from 'src/app/_common/constant/page-const';
import { ChildDeceasedValidation } from './child-deceased.validator';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'child-deceased',
      templateUrl: './child-deceased.component.html',
      styleUrls: ['./child-deceased.component.less']
})
export class ChildDeceasedComponent {

       @Input('still-birth') stillBirth: string = "Y";
       @Input ('ng-model')  input:string;
       @Output('ng-modelChange')  inputChange = new EventEmitter<string>();

       public orgContactPath = Path.ORGContactInformation;

       private childDeceasedValidator:ChildDeceasedValidation;

       public error_isChildDeceased: string;
       
       constructor( public items:ItemList,
                    public data:InputData,
                    public viewportScroller: ViewportScroller ) {

                    this.childDeceasedValidator  = new ChildDeceasedValidation(this);
       }

       public validate() : boolean {
              return this.childDeceasedValidator.validate();
       }


       public onChange() {
              this.inputChange.emit(this.input);
       }
}